import * as FormClasses from './form';
import {
  InputComponentType
} from '@/libs/enums';
import ListConfig from 'libs/classes/listconfig.js';
import {
  getVar
} from 'libs/listconfigs.js';

class SpecificationForm {
  constructor(formcontrol, groups) {
    this.form = formcontrol;
    this.groups = groups;
  }

  get Data() {
    return this.form.getFormData();
  }

  set Data(viewmodel) {
    this.form.loadData(viewmodel);
  }
}

export const CreateForm = (viewmodel) => {
  let form = new FormClasses.FormControl();
  let groups = [];

  if (viewmodel.Properties && viewmodel.Properties.length > 0) {
    AddFormItems(form, viewmodel.Properties);
  }

  if (viewmodel.Groups && viewmodel.Groups.length > 0) {
    groups = viewmodel.Groups.map(g => {
      return {
        ...g,
        Properties: viewmodel.Properties.filter(x => x.GroupID === g.GroupID).map(x => x.FieldName)
      };
    });
  } else {
    groups = [{
      Properties: viewmodel.Properties.map(x => x.FieldName)
    }];
  }

  return new SpecificationForm(form, groups);
};

const AddFormItems = (formcontrol, properties) => {
  properties.forEach(prop => {
    formcontrol.add(GetFormControl(prop));
  });
};

const GetFormControl = (prop) => {
  let result = null;

  switch (prop.Component) {
    case InputComponentType.BoolInput:
      result = new FormClasses.FormBooleanConfig(prop.FieldName, prop.Label, prop.Value, prop.Required, prop.Enabled);
      result.quantityUnit = prop.QuantityUnit;
      break;
    case InputComponentType.DateTimeInput:
      result = new FormClasses.DateTimeConfig(prop.FieldName, prop.Label, prop.Value, true, true, true, false, false, prop.Required, prop.Enabled);
      result.quantityUnit = prop.QuantityUnit;
      break;
    case InputComponentType.ListInput:
      result = new FormClasses.ListFormConfig(prop.FieldName, prop.Label, prop.Value, GetListConfig(prop.Settings), prop.Required, prop.Enabled);
      result.quantityUnit = prop.QuantityUnit;
      break;
    case InputComponentType.NumericInput:
      result = new FormClasses.FormNumericConfig(prop.FieldName, prop.Label, prop.Value, prop.Required, prop.Enabled);
      result.setMinMaxStep(prop.Settings.min, prop.Settings.max, prop.Settings.step);
      result.quantityUnit = prop.QuantityUnit;
      break;
    case InputComponentType.SelectInput:
      result.quantityUnit = prop.QuantityUnit;
      break;
    case InputComponentType.TextAreaInput:
      result = new FormClasses.FormTextAreaConfig(prop.FieldName, prop.Label, prop.Value, prop.Required, prop.Enabled);
      result.quantityUnit = prop.QuantityUnit;
      break;
    case InputComponentType.TextInput:
      result = new FormClasses.FormTextConfig(prop.FieldName, prop.Label, prop.Value, prop.Required, prop.Enabled);
      result.maxlength = prop.Settings.FieldLength;
      result.quantityUnit = prop.QuantityUnit;
      break;
  }
  return result;
};

const GetListConfig = (settings) => {
  if (settings.ListConfig) {
    let listconfig = settings.ListConfig;
    return new ListConfig(listconfig.ListMethod, listconfig.SingleMethod, listconfig.Parameters);
  }
};
